import { onInstallService } from './handlers/install'

// TODO - Split what is widtget, what is config slack
export const D4SIGN_WIDGET = {
  id: 'D4SIGN_INTEGRATION',
  type: 'TOKEN',
  name: 'Integração com d4sign',
  description: 'Criar integração com o D4sign',
  color: 'cyan',
  image: '/services/d4sign.png',
  categories: ['Jurídico'],
  service: 'd4sign',
  onClick: onInstallService,
  initialState: {
    name: 'Jurídico',
    data: {
      type: 'O_OUTH'
    }
  }
}
